/**
 * @file Contains a hook to determine whether the compose should be shown
 */
import useIsComposeOpen from '../../../hooks/router/search/useIsComposeOpen';
import useIsMobile from '../../../hooks/useIsMobile';

/**
 * Hook to determine whether the compose should be shown
 *
 * @param isDraftChanged Whether the draft has been changed
 * @returns              Whether the compose should be shown
 */
const useShouldShowCompose = (isDraftChanged: boolean) => {
  const isComposeOpen = useIsComposeOpen();
  const isMobile = useIsMobile();

  return isComposeOpen || (isDraftChanged && !isMobile);
};

export default useShouldShowCompose;
